import { VehicleTypeCategoryEnum } from "../../vehicleTypes/api/Representation";
export var FeatureTypeEnum;
(function (FeatureTypeEnum) {
    FeatureTypeEnum["VEHICLE"] = "VEHICLE";
    FeatureTypeEnum["DRIVER"] = "DRIVER";
})(FeatureTypeEnum || (FeatureTypeEnum = {}));
export var FeatureComplianceRuleEnum;
(function (FeatureComplianceRuleEnum) {
    FeatureComplianceRuleEnum["NONE"] = "NONE";
    FeatureComplianceRuleEnum["OPTIONAL"] = "OPTIONAL";
    FeatureComplianceRuleEnum["MANDATORY"] = "MANDATORY";
})(FeatureComplianceRuleEnum || (FeatureComplianceRuleEnum = {}));
